import React from 'react';
import { CardContainer } from './styles';
import PlayerCardHeader from './player-card-header';
import { TournamentUser } from 'modules/teams/domain/interfaces/tournament-user';
import { DivProps } from '../../../../../../../typings';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';

type Props = {
  teamId: number;
  player: TeamPlayer;
  containerProps?: Omit<DivProps, 'children'>;
  index: number;
};

const PlayersComponentsPlayerCard = (props: Props) => {
  const { teamId, player, index, containerProps } = props;

  return (
    <CardContainer className="last-mb-0 mb-4">
      <PlayerCardHeader teamId={teamId} player={player} containerProps={containerProps} index={index} />
    </CardContainer>
  );
};

export default PlayersComponentsPlayerCard;
